import { SEARCH_KIND } from "@/constants";
import { Search as SearchFull, SearchLight } from "@/types/Search";
import { isBefore, startOfDay } from "date-fns";

type Search = SearchFull | SearchLight;

function sortSearches(a: Search, b: Search) {
  return (a.sorting_position ?? 0) - (b.sorting_position ?? 0);
}

export function groupSearches<T extends Search>(searches: T[]) {
  const inactive: T[] = [];
  const active: T[] = [];
  let saved: T[] = [];

  if (searches?.length) {
    const today = startOfDay(new Date());
    searches
      .filter((a) => a.kind === SEARCH_KIND.REPORT)
      .toSorted(sortSearches)
      .forEach((a) => {
        if (a.end_date !== null && isBefore(a.end_date, today))
          inactive.push(a);
        else active.push(a);
      });

    saved = searches
      .filter((a) => a.kind === SEARCH_KIND.SAVED)
      .toSorted(sortSearches);
  }

  return { saved, active, inactive };
}
